.sider {
  position: fixed;
  z-index: 10;
  min-height: 100vh;
  box-shadow: 0 1px 2px var(--color-column);

  .header {
    position: relative;
    height: 64px;
    padding-left: 24px;
    overflow: hidden;
    line-height: 64px;
    transition: all 0.3s;
    box-shadow: 0 1px 0 0 var(--color-grey-medium);
    a {
      text-decoration: none;
    }
  }

  .logo {
    display: inline-block;
    height: 32px;
    vertical-align: middle;
  }

  .logotype {
    display: inline-block;
    height: 24px;
    vertical-align: middle;
    margin: 4px 0 0 6px;
  }
}
